import React from "react";
import { Navbar, Container } from "reactstrap";
import "./Bottom.css"; // 추가: CSS 파일을 가져옵니다.

const CustomButton = ({ text, isActive, onClick }) => {
  const buttonClassName = `navbar-toggler custom-button ${isActive ? "active" : ""}`;

  return (
    <button className={buttonClassName} type="button" onClick={onClick}>
      {text}
    </button>
  );
};

const CustomNavbar = ({ activeItem, onMenuClick }) => {
  return (
    <Navbar className="navbar-vertical fixed-bottom navbar-light bg-white" expand="md" id="sidenav-main">
      <Container>
        <CustomButton text="체크리스트" isActive={activeItem === "체크리스트"} onClick={() => onMenuClick("체크리스트")} />
        <CustomButton text="비밀차트" isActive={activeItem === "비밀차트"} onClick={() => onMenuClick("비밀차트")} />
        <CustomButton text="환자정보전달" isActive={activeItem === "환자정보전달"} onClick={() => onMenuClick("환자정보전달")} />
        {/*<CustomButton text="환자분석" isActive={activeItem === "환자분석"} onClick={() => onMenuClick("환자분석")} />*/}
        <CustomButton text="게시판" isActive={activeItem === "게시판"} onClick={() => onMenuClick("게시판")} />
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
